/** Sub-route tab → hoofdmenu-id (verborgen rapportage = ook KPI/ratio's verbergen). */
export const SIDEBAR_SUB_TAB_PARENT: Record<string, string> = {
  reporting_kpi: 'reporting',
  reporting_ratios: 'reporting',
  docs: 'documentbuilder',
  cv_templates: 'documentbuilder',
  doc_shortcodes: 'documentbuilder',
};

export function sidebarGroupIdForTab(tab: string): string {
  return SIDEBAR_SUB_TAB_PARENT[tab] || tab;
}
